module.exports = __webpack_public_path__ + "static/media/pay (1).34b6d21b.png";